/**
 * `v3.host.outcomes.*` — the loop host's side of outcome storage, authenticated by its run
 * token ({@link V3HostMiddleware}), like `v3.host.checks.*`. Payloads live in
 * `@fm/v3/outcomes`.
 *
 * - `uploadUrl` — a presigned PUT for one file of an outcome the host records, under the
 *   caller's own customer and run.
 *
 * A separate group from `V3HostRpcs` so its handlers live in their own router file.
 *
 * Handlers: `v3-host-outcomes.router.ts`.
 *
 * @since 1.0.0
 */
import { Rpc, RpcGroup } from "@effect/rpc";
import { OutcomeStorageError, OutcomeUpload, OutcomeUploadInput } from "@fm/v3/outcomes";
import { Schema } from "effect";
import { ValidationError } from "../errors.ts";
import { V3HostMiddleware } from "./v3-host.tags.ts";

/**
 * @since 1.0.0
 */
export class V3HostOutcomeRpcs extends RpcGroup.make(
  Rpc.make("v3.host.outcomes.uploadUrl", {
    payload: OutcomeUploadInput,
    success: OutcomeUpload,
    error: Schema.Union(ValidationError, OutcomeStorageError),
  }).middleware(V3HostMiddleware),
) {}
